import React from "react"

const SVG_BY_NAME = {
  zap: (
    <svg
      width="25"
      height="55"
      viewBox="0 0 25 55"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0492 24.1311H14.719L20.588 1.92485C20.7141 1.5124 20.7141 0.618543 19.8938 0.137408C19.7044 -4.09782e-08 19.5152 0 19.2628 0C18.5686 0 18.1267 0.618807 18.1267 0.687499L0.267239 27.3625C0.267239 27.4312 -0.17443 28.2563 0.0778323 29.4937C0.393371 30.8 1.71858 30.9374 1.78163 30.9374H10.6798L4.8108 53.1436C4.68467 53.5561 4.68467 54.3812 5.44188 54.7937C5.63129 54.9311 5.88355 55 6.13601 55C6.83015 55 7.20874 54.3812 7.27206 54.3812L24.6267 27.5C24.6267 27.4313 25.3208 26.4687 24.8161 25.3688C24.3113 23.9935 23.1124 24.131 23.0492 24.131V24.1311Z"
        fill="currentColor"
      />
    </svg>
  ),
  facebook: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3445)">
        <path
          d="M44.4706 22.3705C44.4706 10.0911 34.5147 0.135254 22.2353 0.135254C9.95585 0.135254 0 10.0911 0 22.3705C0 33.4697 8.13071 42.6677 18.761 44.3353V28.7984H13.1151V22.3687H18.761V17.4732C18.761 11.9014 22.0815 8.82184 27.1604 8.82184C29.5915 8.82184 32.1374 9.25728 32.1374 9.25728V14.729H29.3321C26.5693 14.729 25.7077 16.443 25.7077 18.2014V22.3705H31.8743L30.8885 28.8003H25.7077V44.3372C36.3399 42.6677 44.4706 33.4678 44.4706 22.3705Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3445">
          <rect width="44.4706" height="44.4706" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  instagram: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3447)">
        <path
          d="M22.706 0C16.6654 0 15.9113 0.0277941 13.5395 0.133412C11.1714 0.244588 9.55938 0.617029 8.14188 1.16735C6.67991 1.73435 5.43844 2.49591 4.20253 3.73182C2.96661 4.96774 2.2032 6.20735 1.63806 7.67118C1.08773 9.08868 0.713438 10.7007 0.604115 13.0688C0.492938 15.4406 0.470703 16.1947 0.470703 22.2353C0.470703 28.2759 0.498497 29.03 0.604115 31.4018C0.715291 33.768 1.08773 35.3819 1.63806 36.7994C2.20506 38.2595 2.96661 39.5029 4.20253 40.7388C5.43844 41.9728 6.67806 42.7381 8.14188 43.3032C9.56123 43.8517 11.1733 44.2279 13.5395 44.3372C15.9113 44.4484 16.6654 44.4706 22.706 44.4706C28.7466 44.4706 29.5007 44.4428 31.8725 44.3372C34.2387 44.226 35.8526 43.8517 37.2701 43.3032C38.7302 42.7362 39.9736 41.9728 41.2095 40.7388C42.4435 39.5029 43.2088 38.2651 43.7739 36.7994C44.3224 35.3819 44.6986 33.768 44.8079 31.4018C44.9191 29.03 44.9413 28.2759 44.9413 22.2353C44.9413 16.1947 44.9135 15.4406 44.8079 13.0688C44.6967 10.7026 44.3224 9.08682 43.7739 7.67118C43.2069 6.20921 42.4435 4.96774 41.2095 3.73182C39.9736 2.49591 38.7358 1.7325 37.2701 1.16735C35.8526 0.617029 34.2387 0.242735 31.8725 0.133412C29.5007 0.0222353 28.7466 0 22.706 0ZM22.706 4.00235C28.641 4.00235 29.3488 4.032 31.6928 4.13391C33.8607 4.23582 35.0373 4.59529 35.8193 4.90288C36.8606 5.30497 37.5981 5.78674 38.38 6.56312C39.1564 7.34135 39.6382 8.08068 40.0403 9.12203C40.3441 9.90397 40.7073 11.0806 40.8055 13.2485C40.9111 15.5944 40.9352 16.2985 40.9352 22.2353C40.9352 28.1721 40.9074 28.8781 40.7981 31.2221C40.6851 33.39 40.3238 34.5666 40.018 35.3486C39.603 36.3899 39.1305 37.1274 38.3522 37.9093C37.5759 38.6857 36.8254 39.1675 35.7952 39.5696C35.0169 39.8734 33.8218 40.2366 31.6539 40.3348C29.2932 40.4404 28.5984 40.4645 22.6504 40.4645C16.7006 40.4645 16.0058 40.4367 13.647 40.3274C11.4772 40.2144 10.282 39.8531 9.50379 39.5473C8.44947 39.1323 7.72497 38.6598 6.94859 37.8815C6.1685 37.1051 5.67006 36.3547 5.28094 35.3245C4.9752 34.5462 4.61573 33.3511 4.5027 31.1831C4.41932 28.8484 4.38967 28.1276 4.38967 22.2075C4.38967 16.2855 4.41932 15.5629 4.5027 13.2004C4.61573 11.0324 4.9752 9.83912 5.28094 9.06088C5.67006 8.00471 6.1685 7.28206 6.94859 6.50197C7.72497 5.72559 8.44947 5.22529 9.50379 4.83803C10.282 4.53044 11.4512 4.16912 13.6192 4.05794C15.9817 3.97456 16.6765 3.94676 22.6226 3.94676L22.706 4.00235ZM22.706 10.8175C16.3967 10.8175 11.2882 15.9316 11.2882 22.2353C11.2882 28.5446 16.4023 33.6531 22.706 33.6531C29.0153 33.6531 34.1238 28.539 34.1238 22.2353C34.1238 15.926 29.0097 10.8175 22.706 10.8175ZM22.706 29.6471C18.611 29.6471 15.2942 26.3303 15.2942 22.2353C15.2942 18.1403 18.611 14.8235 22.706 14.8235C26.801 14.8235 30.1178 18.1403 30.1178 22.2353C30.1178 26.3303 26.801 29.6471 22.706 29.6471ZM37.2442 10.3672C37.2442 11.8403 36.0472 13.0354 34.5759 13.0354C33.1029 13.0354 31.9077 11.8384 31.9077 10.3672C31.9077 8.89597 33.1047 7.70082 34.5759 7.70082C36.0453 7.69897 37.2442 8.89597 37.2442 10.3672Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3447">
          <rect
            width="44.4706"
            height="44.4706"
            fill="white"
            transform="translate(0.470703)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  linkedin: (
    <svg
      width="46"
      height="45"
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3449)">
        <path
          d="M38.8285 37.8964H32.2431V27.5773C32.2431 25.1166 32.1931 21.9499 28.8115 21.9499C25.378 21.9499 24.8536 24.6274 24.8536 27.3957V37.8964H18.2683V16.6765H24.5942V19.5689H24.6794C25.5633 17.9013 27.7127 16.141 30.9238 16.141C37.5963 16.141 38.8303 20.5324 38.8303 26.2488L38.8285 37.8964ZM10.8306 13.7729C8.71079 13.7729 7.00794 12.0571 7.00794 9.94659C7.00794 7.83794 8.71264 6.12397 10.8306 6.12397C12.9429 6.12397 14.655 7.83794 14.655 9.94659C14.655 12.0571 12.9411 13.7729 10.8306 13.7729ZM14.1325 37.8964H7.52861V16.6765H14.1325V37.8964ZM42.123 0H4.22297C2.40894 0 0.941406 1.43418 0.941406 3.20374V41.2669C0.941406 43.0383 2.40894 44.4706 4.22297 44.4706H42.1175C43.9296 44.4706 45.412 43.0383 45.412 41.2669V3.20374C45.412 1.43418 43.9296 0 42.1175 0H42.123Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3449">
          <rect
            width="44.4706"
            height="44.4706"
            fill="white"
            transform="translate(0.941406)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  pinterest: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3451)">
        <path
          d="M22.2638 0.470703C9.99552 0.470703 0.0507812 10.4154 0.0507812 22.6819C0.0507812 32.093 5.90237 40.1311 14.1665 43.3644C13.9719 41.606 13.7978 38.9118 14.2425 36.9922C14.6483 35.256 16.8477 25.9542 16.8477 25.9542C16.8477 25.9542 16.1825 24.6201 16.1825 22.6541C16.1825 19.5727 17.9743 17.2602 20.1997 17.2602C22.0971 17.2602 23.0124 18.6851 23.0124 20.388C23.0124 22.2946 21.8025 25.1445 21.1743 27.7849C20.6462 29.9955 22.2861 31.7965 24.4633 31.7965C28.4063 31.7965 31.4452 27.6367 31.4452 21.6294C31.4452 16.3282 27.6225 12.6075 22.1656 12.6075C15.8471 12.6075 12.1431 17.3547 12.1431 22.2409C12.1431 24.155 12.8731 26.2118 13.7903 27.3198C13.9738 27.5422 13.9979 27.7367 13.9478 27.9591C13.7811 28.6539 13.4049 30.1808 13.329 30.4846C13.2308 30.9016 13.0103 30.9868 12.5859 30.7904C9.81578 29.5119 8.07772 25.4576 8.07772 22.1816C8.07772 15.1849 13.1696 8.74409 22.753 8.74409C30.4575 8.74409 36.45 14.2418 36.45 21.572C36.45 29.2339 31.6193 35.3986 24.9006 35.3986C22.6511 35.3986 20.5388 34.2331 19.7902 32.8434L18.4023 38.1206C17.9039 40.0569 16.542 42.4787 15.6266 43.95C17.7075 44.5892 19.8995 44.9413 22.2045 44.9413C34.4469 44.9413 44.412 35.0003 44.412 22.7301C44.412 10.4581 34.4469 0.51888 22.2045 0.51888L22.2638 0.470703Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3451">
          <rect
            width="44.4706"
            height="44.4706"
            fill="white"
            transform="translate(0 0.470703)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  reddit: (
    <svg
      width="46"
      height="45"
      viewBox="0 0 46 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3455)">
        <path
          d="M23.1767 0.470703C17.2795 0.470703 11.6239 2.81334 7.45397 6.98327C3.28405 11.1532 0.941406 16.8088 0.941406 22.706C0.941406 28.6032 3.28405 34.2588 7.45397 38.4287C11.6239 42.5986 17.2795 44.9413 23.1767 44.9413C29.0739 44.9413 34.7295 42.5986 38.8994 38.4287C43.0694 34.2588 45.412 28.6032 45.412 22.706C45.412 16.8088 43.0694 11.1532 38.8994 6.98327C34.7295 2.81334 29.0739 0.470703 23.1767 0.470703ZM32.4599 9.26106C33.7348 9.26106 34.7761 10.3006 34.7761 11.5754C34.7697 12.1763 34.5299 12.7513 34.1074 13.1787C33.6849 13.6062 33.1128 13.8527 32.512 13.8661C31.9111 13.8796 31.3286 13.659 30.8874 13.2509C30.4461 12.8428 30.1808 12.2792 30.1475 11.6791L25.3354 10.6656L23.853 17.6086C27.2328 17.7383 30.3013 18.7796 32.5137 20.3657C33.0844 19.7932 33.8663 19.4559 34.7502 19.4559C36.5438 19.4559 38.0002 20.9123 38.0002 22.706C38.0002 24.0327 37.1942 25.176 36.1288 25.6966C36.1816 26.0151 36.2077 26.3374 36.2066 26.6602C36.2066 31.652 30.4069 35.684 23.2286 35.684C16.0503 35.684 10.2506 31.652 10.2506 26.6602C10.2506 26.3211 10.2784 25.982 10.3303 25.6707C9.75664 25.4162 9.26933 25.0005 8.92755 24.4741C8.58577 23.9478 8.40425 23.3336 8.40505 22.706C8.40505 20.9123 9.86147 19.4559 11.6551 19.4559C12.513 19.4559 13.3191 19.8191 13.8916 20.3639C16.1281 18.7277 19.2244 17.7142 22.682 17.6086L24.3218 9.85956C24.361 9.71036 24.4532 9.58058 24.5812 9.49453C24.7143 9.41705 24.8707 9.38946 25.0222 9.4167L30.4069 10.56C30.5889 10.1696 30.879 9.83977 31.243 9.60952C31.6069 9.37927 32.0293 9.25832 32.4599 9.26106ZM18.0811 22.706C16.8044 22.706 15.7649 23.7474 15.7649 25.0222C15.7649 26.2951 16.8044 27.3346 18.0811 27.3346C19.3541 27.3346 20.3936 26.2951 20.3936 25.0203C20.3936 23.7455 19.3541 22.706 18.0793 22.706H18.0811ZM28.2723 22.706C26.9993 22.706 25.9598 23.7455 25.9598 25.0222C25.9598 26.2951 26.9993 27.3346 28.2741 27.3346C29.549 27.3346 30.5885 26.2951 30.5885 25.0203C30.5885 23.7473 29.5471 22.706 28.2723 22.706ZM18.1441 30.0992C17.984 30.0985 17.8301 30.1611 17.7161 30.2734C17.6035 30.3878 17.5404 30.5419 17.5404 30.7024C17.5404 30.8629 17.6035 31.0169 17.7161 31.1313C19.2763 32.6915 22.3188 32.8231 23.2026 32.8231C24.0865 32.8231 27.1031 32.7193 28.6892 31.1313C28.7975 31.0174 28.8623 30.869 28.8721 30.7121C28.8819 30.5553 28.8362 30.3999 28.7429 30.2734C28.6285 30.1603 28.474 30.0968 28.3131 30.0968C28.1521 30.0968 27.9976 30.1603 27.8832 30.2734C26.8696 31.261 24.7628 31.6261 23.2286 31.6261C21.6943 31.6261 19.5616 31.2629 18.574 30.2734C18.5175 30.2171 18.4504 30.1726 18.3767 30.1424C18.3029 30.1122 18.2238 30.0988 18.1441 30.0992Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3455">
          <rect
            width="44.4706"
            height="44.4706"
            fill="white"
            transform="translate(0.941406 0.470703)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  twitter: (
    <svg width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
      <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
    </svg>
  ),
  x: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1804_3453)">
        <path
          d="M35.4931 2.60742H42.312L27.4143 19.636L44.9413 42.8033H31.2184L20.4713 28.7506L8.17153 42.8033H1.349L17.2843 24.5889L0.470703 2.60927H14.5419L24.2569 15.4539L35.4931 2.60742ZM33.101 38.7231H36.8791L12.4889 6.47451H8.43464L33.101 38.7231Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1804_3453">
          <rect
            width="44.4706"
            height="44.4706"
            fill="white"
            transform="translate(0.470703 0.470703)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  gasPump: (
    <svg
      width="29"
      height="30"
      viewBox="0 0 29 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2260_9636)">
        <path
          d="M15.9608 9.6239C15.4878 8.95385 15.6849 8.00785 16.3944 7.61365L23.1346 3.9479C23.6471 3.6326 23.8048 3.0019 23.5288 2.48946L22.9376 1.54346C22.6616 1.1099 22.0704 0.952206 21.5974 1.18871L13.5959 5.52446C13.2806 5.68216 12.9652 5.83976 12.6893 5.99746C11.428 6.82521 10.6003 7.96826 9.73308 9.19021C7.36808 12.383 5.04257 15.5757 2.71683 18.7685C2.44089 19.1232 2.16503 19.5962 2.12558 19.9904C2.12558 22.5527 1.21903 24.8387 0.391282 27.1249C0.273032 27.4009 0.43073 27.7162 0.706584 27.8344L3.15034 28.9775C3.46564 29.1352 3.85984 28.9775 3.93864 28.6227C4.17514 27.8738 4.37219 27.1249 4.60869 26.4154C4.84519 25.5877 5.27874 25.2329 6.18539 25.1541C7.95914 24.9964 9.73289 24.8388 11.4279 24.4841C12.2556 24.3264 13.2016 23.8534 13.7534 23.2227C15.4877 21.2125 17.0644 19.084 18.6804 16.9555C19.7841 15.4971 19.7841 14.8664 18.6804 13.3292C17.774 12.1072 16.8673 10.8853 15.9607 9.624L15.9608 9.6239ZM12.7286 18.0197C12.5709 18.2167 12.4526 18.3744 12.295 18.5715C10.7183 20.7394 10.5607 20.976 8.11679 20.8577C7.68324 20.8182 7.40729 20.3452 7.64379 19.9511L12.2555 11.8706C12.492 11.9889 12.5708 12.0283 12.6497 12.1071C15.0542 14.9846 15.0542 14.9846 12.7285 18.0196L12.7286 18.0197Z"
          fill="currentColor"
        />
        <path
          d="M25.2662 6.03689C24.4779 6.98289 23.1377 8.71715 23.0589 9.70264C22.9801 11.0822 24.0049 12.2646 25.3451 12.3436C26.6853 12.4224 27.8679 11.3582 27.9466 9.97864C27.9861 8.99319 26.8824 7.10114 26.2123 6.07639C26.0546 5.72164 25.5422 5.72164 25.2662 6.03694V6.03689Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2260_9636">
          <rect
            width="28.38"
            height="28.38"
            fill="currentColor"
            transform="translate(0 0.873413)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  youtube: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.5518 13.5C44.5518 13.5 44.1123 10.3975 42.7588 9.03516C41.0449 7.24219 39.1289 7.2334 38.25 7.12793C31.957 6.6709 22.5088 6.6709 22.5088 6.6709H22.4912C22.4912 6.6709 13.043 6.6709 6.75 7.12793C5.87109 7.2334 3.95508 7.24219 2.24121 9.03516C0.887695 10.3975 0.457031 13.5 0.457031 13.5C0.457031 13.5 0 17.1475 0 20.7861V24.1963C0 27.835 0.448242 31.4824 0.448242 31.4824C0.448242 31.4824 0.887695 34.585 2.23242 35.9473C3.94629 37.7402 6.19629 37.6787 7.19824 37.8721C10.8018 38.2148 22.5 38.3203 22.5 38.3203C22.5 38.3203 31.957 38.3027 38.25 37.8545C39.1289 37.749 41.0449 37.7402 42.7588 35.9473C44.1123 34.585 44.5518 31.4824 44.5518 31.4824C44.5518 31.4824 45 27.8437 45 24.1963V20.7861C45 17.1475 44.5518 13.5 44.5518 13.5ZM17.8506 28.3359V15.6885L30.0059 22.0342L17.8506 28.3359Z"
        fill="currentColor"
      />
    </svg>
  ),
  google: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.9765 19.1295H40.5V19.0909H22.5V25.9091H33.7471C32.0641 30.8264 27.6952 34.3636 22.5 34.3636C15.8334 34.3636 10.4318 28.962 10.4318 22.2955C10.4318 15.6289 15.8334 10.2273 22.5 10.2273C25.5337 10.2273 28.2873 11.3878 30.4021 13.2764L35.2725 8.40599C31.9019 5.27917 27.4303 3.40909 22.5 3.40909C12.0641 3.40909 3.61365 11.8595 3.61365 22.2955C3.61365 32.7314 12.0641 41.1818 22.5 41.1818C32.9359 41.1818 41.3864 32.7314 41.3864 22.2955C41.3864 21.2223 41.2337 20.1559 41.9765 19.1295Z"
        fill="currentColor"
      />
    </svg>
  ),
}

const SVG = ({
  name,
  scale = 1,
}: {
  name: keyof typeof SVG_BY_NAME
  scale?: number
}) => {
  const SvgComponent = SVG_BY_NAME[name]
  if (!SvgComponent) return null // If SVG not found, return null or you can return a fallback SVG.

  return React.cloneElement(SvgComponent, {
    style: { transform: `scale(${scale})` },
  })
}

export default SVG
